module.exports = __webpack_public_path__ + "img/crm-back.fdd3dc1.png";